import { SettingsSections } from "@payezy/auth";
import { PageHeader } from "@payezy/ui";
import { kratos } from "../lib/api";

export function SecurityPage() {
  return (
    <>
      <PageHeader title="Passkeys & MFA" description="The back office requires a passkey or authenticator app. Keep backup codes somewhere safe; lost factors are reset by another superadmin." />
      <div className="max-w-2xl"><SettingsSections kratos={kratos} returnTo={window.location.href} /></div>
    </>
  );
}
